import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const tableSlice = createSlice({
    name: "tables",
    initialState,
    reducers : {
        addTableName : (state, action) => {
            const newTableName = action.payload;
            state.push(action.payload);
        },
        removeTableName : (state, action) => {
            const tableName = action.payload;
            let result = state.filter((i => v => v !== tableName || --i)(1));
            state.splice(0, state.length)
            state.push(...result)
        },
        resetTableNames : (state) => initialState
    }
});

export const { addTableName, removeTableName, resetTableNames } = tableSlice.actions;

export const table_state = (state) => state.tables;

export default tableSlice.reducer;